export enum ActiveDirectorySearchType {
    User = 'adUser',
    Group = 'adGroup',
    All = 'adAllGroup',
}
